module.exports = __webpack_public_path__ + "files/086a312c24ba5fb61a49ea4a5d155171.png";